import React, { Component } from "react";

import "./toggleInvisibilityOnScroll.css";

class ToggleInvisibilityOnScroll extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrolled: false
    };

    this.onScrollHandler = this.onScrollHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScrollHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScrollHandler() {
    // if scroll is greater than x, set scrolled to true
    if (window.scrollY > 100 && this.state.scrolled !== true) {
      this.setState({
        scrolled: true
      });
    } else if (window.scrollY < 100 && this.state.scrolled !== false) {
      this.setState({
        scrolled: false
      });
    }
  }

  render() {
    return (
      <div className="toggleInvisibilityOnScrollContainer">
        <div
          className={
            this.state.scrolled === true
              ? "toggleInvisibilityOnScroll scrolled"
              : "toggleInvisibilityOnScroll"
          }
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ToggleInvisibilityOnScroll;
